import { Pipe, PipeTransform } from '@angular/core';
import {Product} from "../model/product";

@Pipe({
  name: 'search'
})
export class SearchPipe implements PipeTransform {

  transform(value: any, searchText: any, whereToSearch:string): any {
    if(!searchText && whereToSearch !== 'orderDetailsProperty' && whereToSearch !== 'savedProperties') {
      return null;
    }
    if(whereToSearch === 'existingProperty' || whereToSearch === 'orderDetailsProperty'){
      return value.filter((data) => this.matchValue([data.ownId,data.street,data.town],searchText));
    }
    else if(whereToSearch === 'orderObject'){
      let orders = value.filter((data) => this.matchValue([data.name,data.street,data.town,data.zip,data.id],searchText));
      return orders
    }
    else if(whereToSearch === 'documents'){
      return value.filter((data) => this.matchValue([this.getFullName(data.docname)],searchText));
    }
    else if(whereToSearch === 'savedProperties'){
      if(!searchText)
        return value;
      else
        return value.filter((data) => this.matchValue([data.ownId,data.name,data.street,data.zip,data.town],searchText));
    }
    else if(whereToSearch === 'mandate'){
      return value.filter((data) => this.matchValue([data.name],searchText));
    }
    else{
      return value;
    }
  }

  matchValue(data, value) {
    return Object.keys(data).map((key) => {
      return new RegExp(value, 'gi').test(data[key]);
    }).some(result => result);
  }

  getFullName(shortName) {
    let products: Product[] = JSON.parse(sessionStorage.getItem("products"));
    let product: Product = products.find(obj => obj.nameShort === shortName);
    if(!product)
      return shortName;
    return product.name_long;
  }

}
